import { render, staticRenderFns } from "./ModalPassword.vue?vue&type=template&id=631359ca&scoped=true&lang=pug&"
import script from "./ModalPassword.vue?vue&type=script&lang=ts&"
export * from "./ModalPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPassword.vue?vue&type=style&index=0&id=631359ca&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631359ca",
  null
  
)

export default component.exports